"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const HoverTextInput_1 = require("./HoverTextInput");
const MobilePopover_1 = require("./MobilePopover");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const FormSwitch = ({ displayText, field, description, device, iOSOptions, updateNotificationDeliverable, activePopover, isPopoverOpen, closePopoverModalForm, updateActivePopover, }) => {
    const activePopoverId = `form-switch-info-${field}`;
    const handleUpdateSwitch = () => {
        updateNotificationDeliverable({
            iOSOptions: Object.assign(Object.assign({}, iOSOptions), { contentAvailable: !iOSOptions.contentAvailable }),
        });
    };
    const open = () => {
        updateActivePopover(activePopoverId);
        actions_1.openPopoverModalForm();
    };
    const close = () => {
        switch (device) {
            case 'Mobile':
                closePopoverModalForm();
                setTimeout(() => {
                    updateActivePopover('');
                }, 500);
                break;
            case 'Tablet':
            default:
                updateActivePopover('');
                break;
        }
    };
    const getAlertIconModal = () => {
        const switchElem = React.createElement(src_1.Switch, { on: iOSOptions.contentAvailable || false, onClick: handleUpdateSwitch });
        switch (device) {
            case 'Desktop':
            default:
                return switchElem;
            case 'Tablet':
                return (React.createElement("div", { style: {
                        display: 'flex',
                    } },
                    React.createElement(src_1.PopoverContainer, { id: `form-switch-info-popover`, popoverProps: {
                            placement: 'left',
                            device: device,
                        }, targetParent: "mainModalLeft", onClick: activePopover !== activePopoverId ? open : close, showPopover: activePopover === activePopoverId },
                        React.createElement(src_1.AlertInfoIcon, { fill: src_1.turquoise, style: { marginRight: 16 } }),
                        React.createElement("div", { style: {
                                width: 352,
                                margin: 16,
                            } },
                            React.createElement(src_1.Text, { text: description, size: "medium" }))),
                    switchElem));
            case 'Mobile':
                return (React.createElement("div", { style: {
                        display: 'flex',
                    } },
                    React.createElement(src_1.AlertInfoIcon, { fill: src_1.turquoise, style: { marginRight: 16 }, onClick: (e) => {
                            e.stopPropagation();
                            open();
                        } }),
                    switchElem,
                    activePopover === activePopoverId &&
                        ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { children: React.createElement("div", { style: {
                                    margin: 24,
                                    display: 'flex',
                                    flexDirection: 'column',
                                } },
                                React.createElement(src_1.Text, { size: "h1", text: displayText, textStyle: { marginBottom: 8 } }),
                                React.createElement(src_1.Text, { text: description, size: "medium" })), animation: isPopoverOpen, navbarProps: {
                                buttonLeftCallback: () => close(),
                            } }), document.getElementById('mainModalLeft'))));
        }
    };
    return (React.createElement(HoverTextInput_1.default, { description: description, field: field },
        React.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                minHeight: 72,
                borderBottom: `1px solid ${src_1.titanium}`,
                position: 'relative',
                justifyContent: 'space-between',
                alignItems: 'center',
            }, onClick: handleUpdateSwitch },
            React.createElement(src_1.Text, { text: displayText, size: "large" }),
            getAlertIconModal())));
};
const mapStateToProps = (state) => {
    const { iOSOptions } = reducers_1.getEditableCampaignDeliverable(state);
    return {
        iOSOptions: Object.assign({ categoryIdentifier: null, contentAvailable: false, mutableContent: null, sound: null, threadIdentifier: null }, iOSOptions),
        isPopoverOpen: reducers_1.getIsPopoverModalFormOpen(state),
        activePopover: reducers_1.getActivePopover(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateNotificationDeliverable: (d) => {
            dispatch(actions_1.updateNotificationDeliverable(d));
        },
        openPopoverModalForm: () => {
            dispatch(actions_1.openPopoverModalForm());
        },
        closePopoverModalForm: () => {
            dispatch(actions_1.closePopoverModalForm());
        },
        updateActivePopover: (field) => {
            dispatch(actions_1.updateActivePopover(field));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(FormSwitch);
